function dateFormat(string) {
  // console.log("string", string);
  const date = new Date(string);
  return date.toLocaleDateString("en-US", { dateStyle: "medium" });
}

export default dateFormat;

export function dateFormatTime(string) {
  if (!string) return "";

  const date = new Date(string);

  return date.toLocaleString("en-US", {
    dateStyle: "medium", // Jan 07, 2026
    timeStyle: "short", // 11:24 AM
  });
}

export function generateReferenceNumber(prefix = "REF") {
  const date = new Date();
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  const rand = Math.floor(100000 + Math.random() * 900000); // 6-digit

  return `${prefix}-${y}${m}${d}-${rand}`;
}

export function formatDateTime(dateTime) {
  const date = new Date(dateTime);

  const options = {
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  };

  return date.toLocaleString("en-US", options);
}
